import React from 'react'
import RegisterSimpleContainer from '../../../../component/authentication/register-simple/RegisterSimple'

function Register() {
  return (
    <div className='page-body'>
      <RegisterSimpleContainer />
    </div>
  )
}

export default Register
